export default __webpack_public_path__ + "static/media/american_ring.81fbeeed.svg";